<template>
    <div>
       <div class="container">
         <TextArea
           class="child"
           :textTitle="endpointName"
           :textLinesArray="Description"
         ></TextArea>
         <EndpointCard
           class="child"
           cardTitle="ENDPOINTS"
           :endpoints="endpoints"
         />
       </div>
       <div :ref="endpoints[0].ref" class="container">
         <Attribute
           class="child"
           :endpoint="responseTitleQA"
           :attributes="attributeQASchema"
         />
         <ResponseCard
           class="child"
           :response="responseQA"
           :cardTitle="responseCodeTitleQA"
         />
         </div>
         <div :ref="endpoints[2].ref" class="container">
         <Attribute
           class="child"
           :endpoint="responseTitleMetaData"
           :attributes="attributeMetaData"
         />
         <ResponseCard
           class="child"
           :response="responseMetaData"
           :cardTitle="responseCodeTitleMetaData"
         />
         </div>
         <div :ref="endpoints[4].ref" class="container">
         <Attribute
           class="child"
           :endpoint="responseTitlePDF"
           :attributes="attributePDF"
         />
         <ResponseCard
           class="child"
           :response="responsePDF"
           :cardTitle="responseCodeTitlePDF_REF"
         />
         </div>
    </div>
   </template>
   
   <script>
   import EndpointCard from '../../../components/content/EndpointCard.vue';
   import Attribute from '../../../components/request/Attribute.vue';
   import TextArea from '../../../components/content/TextArea.vue';
   import ResponseCard from '../../../components/request/ResponseCard.vue';
   
   export default {
     components: {
       EndpointCard,
       Attribute,
       TextArea,
       ResponseCard,
     },
       computed: {
         endpoints(){
           return this.$t("qa.controllerEndpoints");
         },
         responseQA(){
           return this.$t("qa.responseQA_REF");
         },
         responseTitleQA(){
           return this.$t("qa.responseTitleQA")
         },
         responseCodeTitleQA(){
           return this.$t("qa.responseCodeTitleQA")
         },
         attributeQASchema(){
           return this.$t("qa.attributeQASchema")
         },
         responseMetaData(){
           return this.$t("qa.response_MetaData")
         },
         responseTitleMetaData(){
           return this.$t("qa.responseTitleMetaData")
         },
         responseCodeTitleMetaData(){
           return this.$t("qa.responseCodeTitleMetaData")
         },
         attributeMetaData(){
           return this.$t("qa.attributeMetaData")
         },
         responsePDF(){
           return this.$t("qa.response_PDF")
         },
         responseTitlePDF(){
           return this.$t("qa.responseTitlePDF")
         },
         responseCodeTitlePDF_REF(){
           return this.$t("qa.responseCodeTitlePDF_REF")
         },
         attributePDF(){
           return this.$t("qa.attributePDF")
         },
         Description(){
           return this.$t("qa.Description")
         },
         endpointName(){
           return this.$t("qa.endpointName")
         }
       },
     };
   </script>
   <style scoped>
   .postCard {
     max-height: 600px;
   }
   
   .container {
     display: flex;
     flex-flow: row wrap;
     padding-left: 10rem;
     padding-right: 10rem;
   }
   
   .child {
     min-width: 40%;
     max-width: 50%;
     flex-grow: 1;
     flex-shrink: 1;
   }
   
   @media screen and (max-width: 500px) {
     .container {
       flex-flow: column wrap;
       padding-left: 1rem;
       padding-right: 1rem;
     }
   }
   
   @media screen and (max-width: 500px) {
     .child {
       max-width: 400px;
       min-width: 300px;
     }
   }
   </style>